import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Eye, EyeOff } from 'lucide-react';
import Logo from '../../images/co_logo.png';
import { acceptUserInvite } from '../../utils/queries';

export default function AcceptInvite() {
	const [searchParams] = useSearchParams();
	const token = searchParams.get('token') || '';
	const [showPassword, setShowPassword] = useState(false);
	const [password, setPassword] = useState('');
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState('');
	const [done, setDone] = useState(false);

	const handleSubmit = async (e) => {
		e.preventDefault();
		setLoading(true);
		setError('');
		const result = await acceptUserInvite(token, password);
		setLoading(false);
		if (!result?.success) {
			setError(result?.error?.message || 'This invite link is invalid or has expired.');
			return;
		}
		setDone(true);
	};

	return (
		<div className='min-h-screen bg-gradient-to-br from-gray-50 to-gray-200 flex items-center justify-center'>
			<div className='w-full max-w-md bg-white p-8 border rounded-2xl'>
				<div className='text-center pb-6'>
					<div className='mx-auto mb-4 w-12x h-12x bg-white rounded-full flex items-center justify-center'>
						<img src={Logo} alt='PI Logo' className='w-[91px] h-[30px]' />
					</div>
					<h1 className='text-2xl font-semibold'>{done ? "You're all set" : 'Accept your invite'}</h1>
					<p className='text-sm text-gray-600 mt-1'>
						{done ? 'Your password has been set.' : 'Set a password to finish joining your team.'}
					</p>
				</div>

				{done ? (
					<a href='/login' className='btn-primary block text-center'>
						Sign In
					</a>
				) : (
					<div className='space-y-6'>
						{error && (
							<div className='border border-pi-red/50 rounded-lg p-3 text-sm text-pi-red'>{error}</div>
						)}
						<form onSubmit={handleSubmit} className='space-y-4'>
							<div className='space-y-2'>
								<label htmlFor='password' className='text-sm font-medium text-gray-700'>
									Password
								</label>
								<div className='relative'>
									<input
										id='password'
										type={showPassword ? 'text' : 'password'}
										placeholder='••••••••'
										value={password}
										onChange={(e) => setPassword(e.target.value)}
										className='form-input pr-10'
										required
										minLength={8}
									/>
									<button
										type='button'
										className='absolute inset-y-0 right-0 pr-3 flex items-center'
										onClick={() => setShowPassword(!showPassword)}
									>
										{showPassword ? <EyeOff className='h-4 w-4 text-gray-400' /> : <Eye className='h-4 w-4 text-gray-400' />}
									</button>
								</div>
							</div>
							<button type='submit' disabled={loading || !token} className='btn-primary disabled:opacity-50 disabled:cursor-not-allowed'>
								{loading ? 'Setting password...' : 'Set Password'}
							</button>
						</form>
					</div>
				)}
			</div>
		</div>
	);
}
